import * as Styled from './styled'
import { Props } from './interfaces'
import { useRef, useState, useEffect } from 'react'

function Popover({ anchor, content, width, closeOnClick, direction = 'right', onChange, onTop }: Props) {
  const anchorRef = useRef<HTMLButtonElement>(null)
  const dropDownRef = useRef<HTMLDivElement>(null)

  const [hasPopover, setPopover] = useState(false)
  const [popoverStyles, setPopoverPopoverStyles] = useState({})

  const directions = {
    left: (renderOnTop) => {
      setPopoverPopoverStyles({ right: 0, top: renderOnTop ? '-125px' : 'unset' })
    },
    right: (renderOnTop) => {
      setPopoverPopoverStyles({ left: 0, top: renderOnTop ? '-125px' : 'unset' })
    },
  }

  function calculatePosition() {
    const { height, top } = anchorRef.current.getBoundingClientRect()
    const size = height + top + 150

    const renderOnTop = onTop || size >= window.innerHeight

    directions[direction](renderOnTop)
  }

  useEffect(() => {
    const handleClickOutside = ({ target }: MouseEvent) => {
      const anchorRefContainsTarget = anchorRef.current.contains(target as Node)
      const dropDownRefContainsTarget = dropDownRef.current?.contains(target as Node)

      if (closeOnClick) {
        setPopover(false)
        return
      }

      if (!dropDownRefContainsTarget && !anchorRefContainsTarget) {
        setPopover(false)
      }
    }

    document.addEventListener('click', handleClickOutside, true)

    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [anchor, direction, closeOnClick])

  return (
    <Styled.Wrapper>
      <Styled.Anchor
        data-testid="popover_anchor"
        type="button"
        ref={anchorRef}
        onClick={(e) => {
          e.preventDefault()
          calculatePosition()
          onChange?.(!hasPopover)
          setPopover(!hasPopover)
        }}
      >
        {anchor}
      </Styled.Anchor>
      <Styled.Popover
        ref={dropDownRef}
        $isOpened={hasPopover}
        $width={width}
        style={{ ...popoverStyles }}
        data-testid="popover_content"
      >
        {content}
      </Styled.Popover>
    </Styled.Wrapper>
  )
}

export default Popover
